import { API_BASE_URL } from "../../api/api";

export const SelectedProductsCards = ({
  selectedProducts,
  getProductDetails,
  getPrice,
  onIncrement,
  onDecrement,
  onRemove,
  formatPrice,
}) => {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 9 }}>
      {selectedProducts.map((item) => {
        const product = getProductDetails(item.productId);
        const image = product.images?.[product.mainImage || 0];
        const imageUrl = image ? `${API_BASE_URL}/product/get/file/${image}` : null;
        const points = product.aditionalData?.[0]?.loyalty_points ?? 0;
        const price = getPrice(product);
        const subtotal = (price * item.quantity).toFixed(2);

        return (
          <div
            key={product.id}
            style={{
              display: "flex",
              alignItems: "center",
              gap: 14,
              background: "#FAFAFF",
              border: "1px solid #EDEFF6",
              borderRadius: 11,
              padding: "13px 14px",
            }}
          >
            {imageUrl ? (
              <img src={imageUrl} alt={product.title} style={{ width: 50, height: 50, borderRadius: 9, objectFit: "cover", flexShrink: 0 }} />
            ) : (
              <div style={{ width: 50, height: 50, borderRadius: 9, background: "#F2F4FA", flexShrink: 0 }} />
            )}

            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ fontSize: 13.5, fontWeight: 700 }}>{product.title}</div>
              <div className="ui-product-row__sku">SKU {product.id?.slice(-8)} · {points} pts</div>
            </div>

            <div className="ui-qty">
              <button type="button" onClick={() => onDecrement(item.productId)}>−</button>
              <span>{item.quantity}</span>
              <button type="button" onClick={() => onIncrement(item.productId)}>+</button>
            </div>

            <div style={{ textAlign: "right", width: 100 }}>
              <div style={{ color: "#8A91AE", fontSize: 11 }}>{formatPrice(price)} c/u</div>
              <div style={{ fontSize: 15, fontWeight: 800, letterSpacing: "-0.02em" }}>{formatPrice(subtotal)}</div>
            </div>

            <button
              type="button"
              onClick={() => onRemove(item.productId)}
              title="Eliminar producto"
              style={{ width: 30, height: 28, flexShrink: 0, border: "1px solid #F6C9C9", borderRadius: 7, background: "#fff", color: "#DC2626", cursor: "pointer" }}
            >
              <i className="ri-delete-bin-line" style={{ fontSize: 13 }} />
            </button>
          </div>
        );
      })}
    </div>
  );
};
